import type { JSX } from 'solid-js';

// Indeterminate spinner — a rotating ring for open-ended waits (webhook install,
// key verification, .maintainer.yml validation) where there's no content to
// skeleton. Skeletons cover content placeholders; this covers "waiting on an
// external event". Decorative (`aria-hidden`): the adjacent text names the wait.
// CSS owns the spin (`.dz-spinner`); reduced-motion keeps the ring, drops the spin.

export type SpinnerProps = {
  readonly size?: string;
  readonly class?: string;
};

export function Spinner(props: SpinnerProps): JSX.Element {
  return (
    <span
      class={`dz-spinner${props.class ? ` ${props.class}` : ''}`}
      style={{ width: props.size, height: props.size }}
      aria-hidden="true"
    />
  );
}
